// extracted by mini-css-extract-plugin
module.exports = {"Container":"Testimonials_Container__nVw31","Tiles":"Testimonials_Tiles__5wAU1","Tile":"Testimonials_Tile__x_dOs","Pending":"Testimonials_Pending__T0IZh"};